<template>
  <div>
    <!--功能按钮组件页面-->
    <avue-crud :data="list" :option="tableOption" :page="page" @size-change="sizeChange" @current-change="currentChange" @search-reset="searchReset" @row-click="showRow" @search-change="searchChange">
      <template slot="search">
        <el-form-item label="师傅信息">
          <el-input v-model="listQuery.condition" clearable placeholder="姓名/手机号码/真实姓名" />
        </el-form-item>
        <el-form-item label="团队认证">
          <el-select v-model="listQuery.isForeman" clearable  placeholder="请选择">
              <el-option label="已认证" value="1"></el-option>
              <el-option label="未认证" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工种类型">
          <el-select v-model="listQuery.workTypeId" clearable  placeholder="请选择">
              <el-option v-for="workType in dic.workTypes" :key="workType.id" :value="workType.code" :label="workType.name" ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot-scope="scope" slot="menuLeft">
          <el-button class="filter-item" :disabled = "totalStatus" size="mini" @click="getInfo" type="primary" icon="el-icon-info">查看详情</el-button>
         <el-button class="filter-item"  :disabled = "totalStatus" size="mini" @click="removeBlack" type="primary" icon="el-icon-delete-solid">移出黑名单</el-button>
      </template>
      <template slot-scope="scope" slot="userId">
          <el-radio class="radio" v-model="radio"  :label="scope.row"></el-radio>
      </template>
    </avue-crud>
    <info ref="info" @refresh='refresh'></info>
 </div>
</template>
<script>
    import {blackWorkerList,removeBlack} from '@/api/admin/workerUser'
    import {getDictList} from '@/api/admin/dict'
    import waves from '@/directive/waves/index.js' // 水波纹指令
    import info from './blackinfo'
    import { objKeySort } from '@/util/ajaxsign'
    import '../../../styles/addProject.scss';
    export default {
        name: 'black_list',
        components: {info},
        directives: { waves },
        data() {
            return {
                list: [],
                radio : '',
                totalStatus : true,
                listLoading : false,
                dic:{
                  workTypes:[],
                  skillTips:[]
                },
                roleManager:{
                  addGroup:false,
                  addBlack:false
                },
                listQuery: {
                  current: 1,
                  size: 10,
                  condition : '',
                  isForeman:'',
                  workTypeId:'',
                  groupId:''
                },
                page: {
                  pageSizes: [10, 20, 50, 100],
                  currentPage: 1,
                  total: 0,
                  pageSize: 10
                },
                tableOption : {
                  addBtn : false,
                  refreshBtn : false,
                  columnBtn : true,
                  editBtn : true,
                  delBtn : true,
                  menu : false,
                  page:true,
                  border : true,
                  align:'center',
                  menuAlign:'center',
                  height : window.innerHeight - 280,
                  index:false,
                  column:[ {
                    label:'',
                    prop:'userId',
                    width:40,
                    solt:true
                  },
                  {
                    label:'姓名',
                    prop:'userName',
                    overHidden : true,
                  },{
                    label:'手机号码',
                    prop:'phone',
                    overHidden : true,
                  },{
                    label:'团队认证',
                    prop:'isForeman',
                    overHidden : true,
                    formatter: function(row){
                        return  row.isForeman ==1? '已认证' : '未认证'
                    }
                  },
                  {
                    label:'真实姓名',
                    prop:'cardUserName'
                  },{
                    label:'身份证号码',
                    prop:'cardNum',
                    overHidden : true,
                    formatter: function(row){
                      var carNum = '';
                      if(row.cardNum&&row.cardNum.length>0){
                        let str = row.cardNum.split("");
                        for(var i = 0;i<str.length;i++){
                          if(i<6||i>=str.length-4){
                            carNum = carNum+str[i];
                          }else{
                            carNum = carNum+"*";
                          }
                        }
                      }
                        return  carNum;
                    }
                  },{
                    label:'工种',
                    prop:'workTypeIds',
                    overHidden : true,
                    formatter:function(row){
                      switch (row.workTypeIds) {
                        case '1':
                            return "搬运工"
                          break;
                          case '2':
                            return "安装工"
                          break;
                          case '3':
                            return "补漆工"
                          break;
                          case '4':
                            return "维修工"
                          break;
                        default:
                          return ''
                          break;
                      }
                    }
                    },{
                      label:'实名状态',
                      prop:'workerState',
                      formatter: function(row){
                        if(row.workerState == 1){
                          return "审核中";
                        }else if(row.workerState == 2){
                          return "已认证";
                        }else{
                          return "未认证";
                        }
                      }
                    }
                  ]
                },
                permissions : [], //权限数据
                infodata : '',
            }
        },
        created() {
          this.initDic();
          this.getList();

        },
        methods: {
            //刷新列表操作
            formatterWorkType(workTypeIds){
                var  workTypeNames = '';
                if(workTypeIds&&workTypeIds.length>0){
                    workTypeIds.split(",").forEach(workerTypeId =>{
                        if(this.dic.workTypes){
                            console.log(this.dic.workTypes)
                            this.dic.workTypes.forEach(workerType => {
                                if(workerType.id==workerTypeId){
                                    workTypeNames = workTypeNames + workerType.name +',';
                                }
                            })
                        }else{
                            return workTypeIds;
                        }

                    })
                }
                if(workTypeNames.length>0){
                    workTypeNames = workTypeNames.substring(0,workTypeNames.length-1);
                }
                return  workTypeNames;
            },
            initDic(){
              getDictList(objKeySort({code:"worktype"})).then(response => {
                  this.dic.workTypes = response.data.data.worktype;
                  console.log(this.workTypes);
              })
               getDictList(objKeySort({code:"worker_skill"})).then(response => {
                  this.dic.skillTips = response.data.data.worker_skill;
              })


            },
            refresh(){
              this.totalStatus = true;
              this.getList()
            },

            //获取列表数据
            getList() {
                this.listLoading = true;
                this.listQuery.isAsc = false;
                blackWorkerList(objKeySort(this.listQuery)).then(response => {
                  this.list = response.data.data;
                  // this.list.forEach(data =>{
                  //   data.workTypeIds = this.formatterWorkType(data.workTypeIds);
                  // })
                  console.log(this.list);
                  this.page.total = response.data.data.length;
                  this.listLoading = false;
                })
            },
            //点击列数据
            showRow(row){
              this.radio = row;
              this.infodata = row;
              if(row){
                this.totalStatus = false;
              }else{
                this.totalStatus=true
              }
            },
            //清空
            searchReset(){
              this.listQuery={};
              this.listQuery.current = 1;
              this.listQuery.size = 20;
              this.getList();
            },

            //条数
            sizeChange(val) {
              this.listQuery.size = val;
              this.getList();
            },
            //页码
            currentChange(val) {
              this.listQuery.current = val;
              this.getList();
            },
            //搜索数据
            searchChange(){
              this.getList();
            },

            getInfo(){
              this.$refs.info.setUserId(this.radio,this.dic);
            },

            removeBlack(){
              let that =this
                that.$confirm(
                '您确定要将用户“' + that.infodata.userName + '”移出到黑名单吗,移出后该用户可以继续接您企业的项目，是否继续?',
                '提示',
                {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }
              ).then(() => {
              removeBlack(objKeySort({bwId:that.infodata.bwId})).then(response => {
                  if(response&&response.data&&response.data.code===200){
                      that.$message({
                          title: '成功',
                          message: '移出黑名单成功',
                          type: 'success',
                          duration: 2000
                      })
                      that.radio=undefined
                      that.totalStatus=true
                      that.getList();
                  }else{
                          that.$message({
                          title: '失败',
                          message: '移出黑名单失败',
                          type: 'error',
                          duration: 2000
                      })
                  }
              });
              })
            }
        }
    }
</script>
<style lang="scss" scoped>

  .el-tag{
    border: 0!important;
    color: #666!important;
    background-color: transparent;
    font-size:14px;
  }
  .dialog-footer{
    margin-left: 0!important;
  }
  .filter-item1{
    width: auto;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    border: 0!important;
    margin-left: 0!important;
    margin-right: 22px;
  }
  .el-table__row:nth-child(even) {
    background-color: #F6F9FF!important;
  }
  .is-required{

  }
  /*.select_role{
    -height:100px;
  }*/
  .el-dialog__footer{
    -height:120px;
  }
  .p1{
    width:100% !important;
  }
  .part{
    position: relative;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-radio__label{
    display:none;
  }
</style>
